module.exports = __webpack_public_path__ + "static/media/charih.a4ce6aa3.png";